/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedDataPrescriptionRowDto } from '../../models/paginated-data-prescription-row-dto';

export interface GetPrescriptionList$Params {
  dateFrom: string;
  dateTo?: string;
  status: 'NO_PRESCRIPTION' | 'SENT' | 'CANCELED';
  target: 'ISABV' | 'TAPS' | 'ALL';
  offset?: number;
  limit?: number;
  type?: 'SINGLE_FARM_ANIMAL_TREATMENT' | 'SUPPLY_FARM_ANIMAL_TREATMENT';
}

export function getPrescriptionList(http: HttpClient, rootUrl: string, params: GetPrescriptionList$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedDataPrescriptionRowDto>> {
  const rb = new RequestBuilder(rootUrl, getPrescriptionList.PATH, 'get');
  if (params) {
    rb.query('dateFrom', params.dateFrom, {});
    rb.query('dateTo', params.dateTo, {});
    rb.query('status', params.status, {});
    rb.query('target', params.target, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('type', params.type, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedDataPrescriptionRowDto>;
    })
  );
}

getPrescriptionList.PATH = '/api/prescriptions';
